export default [
  {path: "/active/drainage", component: () => import('../page/active/drainage')}
]



// WEBPACK FOOTER //
// ./src/router/active.js